import React from 'react';
import Navbar from '../../../components/Navbar';
import Header from '../../../components/Header';
import Section from './Section';

const PemeriksaanMahasiswa = () => (
  <>
    <Navbar />
    <Header />
    <Section />
  </>
);

export default PemeriksaanMahasiswa;
